var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearInverseSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    width: 800,
    height: 800,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m737 463.3l-160.9 160.9c-19.9 19.9-36.6 27.3-72.6 27.3h-377.6c-49.6 0-89.9-40.3-89.9-89.9v-323.7c0-49.6 40.3-89.9 89.9-89.9h377.6c36 0 52.7 7.4 72.6 27.2l160.9 161c35.1 35.1 35.1 92 0 127.1zm-530.7 25.4l46.4 46.4 89-89 89 89 46.3-46.4-89-89 89-89-46.3-46.3-89 89-89-89-46.4 46.3 89 89z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearInverseSvgrepoCom);
export default __webpack_public_path__ + "static/media/clear-inverse-svgrepo-com.e06115b07b34c865bc97380fc781c603.svg";
export { ForwardRef as ReactComponent };